module.exports = __webpack_public_path__ + "img/logo_news_vice@4x.80a6dae4.png";